<template>
  <footer class="site-footer">
    <div class="container py-5">
      <div class="row align-items-center">
        <div class="col-lg-5 mb-4 mb-lg-0">
          <div class="d-flex align-items-center mb-3">
            <img src="../assets/logo.svg" alt="Logo" class="footer-logo mr-3">
            <div>
              <h5 class="mb-1">{{ companyInfo.companyName || "Công ty TNHH NWM Việt Nam" }}</h5>
              <p class="mb-0 footer-copy">Cleaner Water, Bluer Future</p>
            </div>
          </div>
          <p class="footer-copy mb-0">
            {{ companyInfo.description || "Giải pháp vận hành nước an toàn, tinh gọn và hiệu quả cho doanh nghiệp." }}
          </p>
        </div>
        <div class="col-lg-4 mb-4 mb-lg-0">
          <div class="footer-title">Liên hệ</div>
          <div class="footer-copy mb-2">{{ companyInfo.address }}</div>
          <div class="footer-copy mb-2">MST: {{ companyInfo.taxCode }}</div>
          <div class="footer-copy mb-2">{{ companyInfo.phone }}</div>
          <div class="footer-copy mb-2">{{ companyInfo.email }}</div>
          <div v-if="companyInfo.website" class="footer-copy">{{ companyInfo.website }}</div>
        </div>
        <div class="col-lg-3">
          <div class="footer-title">Điều hướng</div>
          <router-link class="footer-link d-block mb-2" :to="{ name: 'home' }">Trang chủ</router-link>
          <router-link class="footer-link d-block mb-2" :to="{ name: 'about' }">Giới thiệu</router-link>
          <router-link class="footer-link d-block mb-2" :to="{ name: 'news' }">Tin tức</router-link>
          <router-link class="footer-link d-block" :to="{ name: 'contact' }">Liên hệ</router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "SiteFooter",
  props: {
    companyInfo: {
      type: Object,
      default: function defaultCompanyInfo() {
        return {};
      }
    }
  }
};
</script>

<style scoped>
.site-footer {
  background: linear-gradient(180deg, #03296a 0%, #00163d 100%);
  color: white;
}

.footer-logo {
  width: 56px;
  height: 56px;
  border-radius: 18px;
  object-fit: cover;
}

.footer-title {
  font-weight: 800;
  margin-bottom: 14px;
}

.footer-copy,
.footer-link {
  color: rgba(255, 255, 255, 0.78);
}

.footer-link:hover {
  color: white;
  text-decoration: none;
}
</style>
